const allowedOrganizationRoles = ['ROLE_SHIPOWNER', 'ROLE_FLEET_MANAGER']
const allowedVesselRoles = ['ROLE_CAPTAIN']

const Security = {
  install(Vue) {
    Vue.prototype.$security = {
      getUser() {
        return JSON.parse(localStorage.getItem('user'))
      },

      setUser(user) {
        return localStorage.setItem('user', JSON.stringify(user))
      },

      removeUser() {
        return localStorage.setItem('user', null)
      },

      isGranted(resource, role) {
        const user = JSON.parse(localStorage.getItem('user'))

        const resourceId = typeof resource === 'string' ? resource : resource['@id']

        if (resourceId.includes('/organizations/')) {
          for (let x in user.roleInOrganizations) {
            let roleInOrganization = user.roleInOrganizations[x]
            if (
              roleInOrganization.organization['@id'] === resourceId &&
              roleInOrganization.organizationRole.name === role
            ) {
              return true
            }
          }
          return false
        } else if (resourceId.includes('/vessels/')) {
          for (let x in user.roleInVessels) {
            let roleInVessel = user.roleInVessels[x]
            if (roleInVessel.vessel['@id'] === resourceId && roleInVessel.vesselRole.name === role) {
              return true
            }
          }
          return false
        }
      },

      getUserVessels() {
        const user = this.getUser()
        let vessels = []

        for (let i in user.roleInVessels) {
          let roleInVessel = user.roleInVessels[i]

          if (!vessels.includes(roleInVessel.vessel)) {
            vessels.push(roleInVessel.vessel)
          }
        }

        return vessels
      },

      getUserOrganizations() {
        const user = this.getUser()
        let organizations = []

        for (let i in user.roleInOrganizations) {
          let roleInOrganization = user.roleInOrganizations[i]

          if (!organizations.includes(roleInOrganization.organization)) {
            organizations.push(roleInOrganization.organization)
          }
        }

        return organizations
      },

      hasRoleInOrganizations(rolesToCheck) {
        const user = this.getUser()
        let hasRole = false

        if (!user.roleInOrganizations) {
          return hasRole
        }

        user.roleInOrganizations.forEach(roleInOrganization => {
          if (rolesToCheck.includes(roleInOrganization.organizationRole.name)) {
            hasRole = true
          }
        })

        return hasRole
      },

      hasRoleInVessels(rolesToCheck) {
        const user = this.getUser()
        let hasRole = false

        if (!user.roleInVessels) {
          return hasRole
        }

        user.roleInVessels.forEach(roleInVessel => {
          if (rolesToCheck.includes(roleInVessel.vesselRole.name)) {
            hasRole = true
          }
        })

        return hasRole
      },

      isAllowed() {
        return (
          this.hasRoleInOrganizations(allowedOrganizationRoles) || Vue.security.hasRoleInVessels(allowedVesselRoles)
        )
      }
    }
    Vue.security = Vue.prototype.$security
  }
}

export default Security
